export class News {
  _id: string;
  title: string;
  content: string;
  status: string;
  creationDate: Date;
  isPublished: boolean;
  hasPush: boolean;
  hasCover: boolean;
  publishDate: Date;
  units: string[];
  categories: string[];
  midias: any[];
}



// WEBPACK FOOTER //
// ./src/app/noticias/shared/news.model.ts